var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{on:{"click":function($event){return _vm.toggleFavorite()}}},[_vm._v("\n    "+_vm._s(this.isFavorite ? this.removeFromFavoriteLabel : this.addToFavoriteLabel)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }